import environmentSettings from "@constants/environmentSettings";

export const isFeatureFlagOn = (flag) => {
  const flagValue = environmentSettings[flag];
  return flagValue === 'true';
};

export const isFeatureFlagOff = (flag) => {
  const flagValue = environmentSettings[flag];
  return flagValue !== 'true';
};

export const isEnvSet = (variable) => {
  const variableValue = environmentSettings[variable];
  if (variableValue !== null && variableValue !== undefined && variableValue !== '') {
    return environmentSettings[variable];
  }
  return false;
};
